const styles = (theme) => ({
  root: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    padding: '20px',
    backgroundColor: theme.palette.common.white,
    borderRadius: 10,
  },
  questionnaireSection: {
    width: '100%',
    paddingRight: 20,
  },
  milestoneSection: {
    width: '100%',
    boxSizing: 'border-box',
    marginTop: 0,
  },
});

export default styles;
